/* Tab (Oct 31, Mordy 8:35 PM): when a shopper picks an option value (e.g. "25 Pack") whose
   combination with the other selected option(s) doesn't exist, switch the other option(s) to the
   first valid variant that has it, so a real variant is selected and its pills light up.
   Runs before Dawn's own variant-selects change handler. Remove this file + its line in
   layout/theme.liquid to undo. */
(function () {
  var cache = {};
  var SKIP = '__tabAutoselectRedispatch';

  function jsUrl(url) {
    if (!url) return null;
    var base = url.split('?')[0].split('#')[0].replace(/\/$/, '');
    return base + '.js';
  }
  function load(url) {
    var u = jsUrl(url);
    if (!u) return Promise.resolve(null);
    if (!cache[u]) {
      cache[u] = { data: null, p: fetch(u, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { cache[u].data = d; return d; })
        .catch(function () { return null; }) };
    }
    return cache[u].p;
  }
  function cached(url) {
    var u = jsUrl(url);
    return u && cache[u] && cache[u].data;
  }
  function productUrlFor(container, target) {
    var t = target && target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    if (t && t.dataset && t.dataset.productUrl) return t.dataset.productUrl;
    var pi = container.closest('product-info');
    return pi && pi.dataset.url;
  }
  function groups(container) {
    return Array.prototype.slice.call(container.querySelectorAll('.product-form__input'))
      .filter(function (g) { return g.querySelector('input[type=radio], select'); });
  }
  function groupValue(g) {
    var sel = g.querySelector('select');
    if (sel) return sel.value;
    var c = g.querySelector('input[type=radio]:checked');
    return c ? c.value : null;
  }
  function setGroupValue(g, value) {
    var sel = g.querySelector('select');
    if (sel) {
      var opts = Array.prototype.slice.call(sel.options);
      var match = opts.find(function (o) { return o.value === value; });
      if (!match) return false;
      opts.forEach(function (o) { o.removeAttribute('selected'); });
      match.setAttribute('selected', 'selected');
      sel.value = value;
      return true;
    }
    var radios = Array.prototype.slice.call(g.querySelectorAll('input[type=radio]'));
    var r = radios.find(function (i) { return i.value === value; });
    if (!r) return false;
    radios.forEach(function (i) { i.checked = (i === r); });
    var label = g.querySelector('[data-selected-value]');
    if (label && !label.querySelector('.swatch')) label.textContent = value;
    return true;
  }
  /* returns true if it changed anything */
  function fix(container, target, product) {
    if (!product || !product.variants) return false;
    var gs = groups(container);
    var pos = gs.findIndex(function (g) { return g.contains(target); });
    if (pos < 0 || gs.length < 2) return false;
    var cur = gs.map(groupValue);
    var picked = cur[pos];
    var exists = product.variants.some(function (v) {
      return cur.every(function (val, i) { return v.options[i] === val; });
    });
    if (exists) return false;
    var best = null, bestScore = -1;
    product.variants.forEach(function (v, idx) {
      if (v.options[pos] !== picked) return;
      var matches = 0;
      cur.forEach(function (val, i) { if (i !== pos && v.options[i] === val) matches++; });
      var score = (v.available ? 1000 : 0) + matches * 10;
      if (score > bestScore) { bestScore = score; best = v; }
    });
    if (!best) return false;
    var changed = false;
    gs.forEach(function (g, i) {
      if (i !== pos && cur[i] !== best.options[i]) changed = setGroupValue(g, best.options[i]) || changed;
    });
    return changed;
  }

  document.addEventListener('change', function (event) {
    if (event[SKIP]) return;
    var target = event.target;
    var container = target && target.closest && target.closest('variant-selects');
    if (!container) return;
    var url = productUrlFor(container, target);
    var product = cached(url);
    if (product) { fix(container, target, product); return; }
    /* data not loaded yet: hold Dawn's handler, load, fix, then replay the change */
    event.stopImmediatePropagation();
    load(url).then(function (p) {
      fix(container, target, p);
      var ev = new Event('change', { bubbles: true });
      ev[SKIP] = true;
      target.dispatchEvent(ev);
    });
  }, true);

  function preload() {
    document.querySelectorAll('variant-selects').forEach(function (c) {
      load(productUrlFor(c, c.querySelector('input:checked, select')));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preload);
  else preload();
  /* quick-add modals etc. */
  var t = null;
  new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; preload(); }, 300); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
